import React from 'react';
import logo from '../../assets/image/image 1.png';
import bgimage from '../../assets/image/Group 171.png';
import { Link } from 'react-router-dom';

function Startedpage() {
  return (
    <>
      <div className="started-container">
        {/* Background image */}
        <img src={bgimage} alt="background" className="bg-image" />

        {/* Foreground content over the image */}
        <div className="content-overlay d-flex flex-column align-items-center justify-content-center text-center">
          <img src={logo} alt="logo" className="logo-img mb-3" />
          <p className="main-text mb-1">
            Discover your next skill<br />
            Learn anything you want!
          </p>
          <p className="sub-text mb-4">Learn and grow</p>
          <Link to='/login'>
          <button className="btn btn-primary px-5 py-2">Get Started</button>
          </Link> 
          <p className="footer-text mt-4 mb-0">www.frwrddtutors.com/</p>
        </div>
      </div>

      {/* Inline CSS - Move to external if needed */}
      <style>
        {`
          .started-container {
            position: relative;
            height: 100vh;
            width: 100%;
            overflow: hidden;
          }

          .bg-image {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: 0;
          }

          .content-overlay {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            height: 100%;
            width: 100%;
            padding-top: 100px;
            color: #333;
          }

          .logo-img {
            width: 220px;
            height: auto;
          }

          .main-text {
            font-size: 18px;
            font-weight: 600;
            color: #333;
          }

          .sub-text {
            color: #888;
            font-size: 14px;
          }

          .footer-text {
            font-size: 12px;
            color: #aaa;
          }

          .btn-primary {
            background-color: #49479D;
            border: none;
            border-radius: 8px;
            font-weight: 500;
            font-size:25px;
          }
        `}
      </style>
    </>
  );
}

export default Startedpage;
